import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './CategorySelector.css';

const CategorySelector = () => {
  const navigate = useNavigate();

  const handleSelect = (category) => {
    navigate(`/display/${category}`);
  };

  return (
    <div className="category-selector">
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="lavender-header"
          >
            <h2 className="lavender-lounge-title">Lavender Lounge</h2>
            <p className="lavender-lounge-subtitle">Hanimaadhoo</p>
          </motion.div>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="selector-content"
      >
        <h1 className="selector-title">Flight Information Display</h1>
        <p className="selector-subtitle">Select flight category to display</p>
        
        <div className="category-buttons">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => handleSelect('domestic')}
            className="category-btn domestic-btn"
          >
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
            >
              <span className="btn-icon">✈️</span>
              <span className="btn-text">Domestic</span>
            </motion.div>
          </motion.button>

          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            onClick={() => handleSelect('international')}
            className="category-btn international-btn"
          >
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.4, type: "spring", stiffness: 200 }}
            >
              <span className="btn-icon">🌍</span>
              <span className="btn-text">International</span>
            </motion.div>
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
};

export default CategorySelector;

